import DIcon from '~@/Components/Common/DIcon'
import DButton from '~@/Components/Common/DButton'
import DButtonDropdown from '~@/Components/Common/Dropdown/DButtonDropdown'
import DDropdownItem from '~@/Components/Common/Dropdown/DDropdownItem'
import DDropdownSpacer from '~@/Components/Common/Dropdown/DDropdownSpacer'
import DCard from '~@/Components/Common/DCard'
import DFormRow from '~@/Components/Common/Forms/DFormRow'
import DFormControls from '~@/Components/Common/Forms/DFormControls'
import DFabs from '~@/Components/Common/DFabs'
import DFab from '~@/Components/Common/DFab'
import DModal from '~@/Components/Common/DModal'
import DTabs from '~@/Components/Common/DTabs'
import DTabItem from '~@/Components/Common/DTabItem'
import DTag from '~@/Components/Common/DTag'
import DInput from '~@/Components/Common/Forms/DInput'
import DFormCheck from '~@/Components/Common/Forms/DFormCheck'
import DSelect from '~@/Components/Common/Forms/DSelect'
import DInputGroup from '~@/Components/Common/Forms/DInputGroup'
import DRow from '~@/Components/Common/DRow'
import DCol from '~@/Components/Common/DCol'
import DDropdown from '~@/Components/Common/Dropdown/DDropdown'
import DFormTextarea from '~@/Components/Common/Forms/DFormTextarea'
import DRadioGroup from '~@/Components/Common/Forms/DRadioGroup'
import DForm from '~@/Components/Common/Forms/DForm'
import DSwitch from '~@/Components/Common/Forms/DSwitch.vue'
import DPagination from '~@/Components/Common/DPagination.vue'
import DTable from '~@/Components/Common/DTable.vue'
import DFileInput from '~@/Components/Common/Forms/DFileInput.vue'
import DToast from '~@/Components/Common/DToast.vue'
import DToaster from '~@/Components/Common/DToaster.vue'

const DogadoComponents = {
    install (Vue, options) {
        Vue.component('DIcon', DIcon)
        Vue.component('DButton', DButton)
        Vue.component('DButtonDropdown', DButtonDropdown)
        Vue.component('DDropdownItem', DDropdownItem)
        Vue.component('DDropdownSpacer', DDropdownSpacer)
        Vue.component('DCard', DCard)
        Vue.component('DFormRow', DFormRow)
        Vue.component('DFormControls', DFormControls)
        Vue.component('DFabs', DFabs)
        Vue.component('DFab', DFab)
        Vue.component('DModal', DModal)
        Vue.component('DTabs', DTabs)
        Vue.component('DTabItem', DTabItem)
        Vue.component('DTag', DTag)
        Vue.component('DInput', DInput)
        Vue.component('DFileInput', DFileInput)
        Vue.component('DFormCheck', DFormCheck)
        Vue.component('DSelect', DSelect)
        Vue.component('DRow', DRow)
        Vue.component('DCol', DCol)
        Vue.component('DInputGroup', DInputGroup)
        Vue.component('DDropdown', DDropdown)
        Vue.component('DFormTextarea', DFormTextarea)
        Vue.component('DRadioGroup', DRadioGroup)
        Vue.component('DForm', DForm)
        Vue.component('DSwitch', DSwitch)
        Vue.component('DPagination', DPagination)
        Vue.component('DTable', DTable)
        Vue.component('DToaster', DToaster)
        Vue.component('DToast', DToast)
    }
}

export default DogadoComponents
